
import NoMatch from '../pages/NoMatch';
import CoefficientiEIndici from "../views/CoefficientiEIndici.jsx";
import StatisticheCliente from "../views/StatisticheCliente.jsx";
import Evolution from "../views/Evolution.jsx";
import Mappa from '../views/Mappa.jsx';
import ImportData from '../views/ImportData.jsx';
import Login from "../views/Login.jsx";
import Documents from '../views/Documents';

const routes = [
  {
    path: "/",
    name: "Challenge| Coefficienti di crescita",
    exact: true,
    auth: true,
    icon: "tim-icons icon-chart-pie-36",
    component: CoefficientiEIndici,
    roles: ['superadmin', 'qcompetitor-strategic', 'qcompetitor-evolution']
  },
  {
    path: "/statistiche-competitor/",
    name: "Statistiche Competitor",
    exact: true,
    auth: true,
    icon: "tim-icons icon-paper",
    component: StatisticheCliente,
    roles: ['superadmin', 'qcompetitor-strategic', 'qcompetitor-evolution']
  },
  {
    path: "/evolution/",
    name: "Evolution",
    exact: true,
    auth: true,
    icon: "tim-icons icon-atom",
    component: Evolution,
    roles: ['superadmin', 'qcompetitor-evolution']
  },
  {
    path: "/evolution/:id",
    name: "Evolution",
    exact: true,
    auth: true,
    icon: "tim-icons icon-atom",
    component: Evolution,
    roles: ['superadmin', 'qcompetitor-evolution']
  },
  {
    path: "/statistiche-competitor/:id",
    name: "Statistiche Competitor",
    exact: true,
    auth: true,
    icon: "tim-icons icon-paper",
    component: StatisticheCliente,
    roles: ['superadmin', 'qcompetitor-strategic', 'qcompetitor-evolution']
  },
  {
    path: "/mappa",
    name: "Mappa |indici sviluppo |Competitor",
    exact: true,
    auth: true,
    icon: "tim-icons icon-chart-bar-32",
    component: Mappa,
    roles: ['superadmin', 'qcompetitor-strategic', 'qcompetitor-evolution']
  },
  {
    path: "/documenti",
    name: "Archivio |Documenti",
    exact: true,
    auth: true,
    icon: "tim-icons icon-chart-pie-36",
    component: Documents,
    roles: ['superadmin', 'qcompetitor-strategic', 'qcompetitor-evolution']
  },
  {
    path: "/import-data",
    name: "Import Data",
    exact: true,
    auth: true,
    icon: "tim-icons icon-cloud-upload-94",
    component: ImportData,
    roles: ['superadmin'] //that means only admin can have access
  },
  // {
  //   path: "/grafico",
  //   name: "Grafico",
  //   exact: true,
  //   auth: true,
  //   component: Grafico1,
  //   layout: "/admin"
  // },
  // {
  //   path: "/grafico2",
  //   name: "Grafico2",
  //   exact: true,
  //   auth: true,
  //   component: Grafico2,
  //   layout: "/admin"
  // },
  // {
  //   path: "/info",
  //   name: "Informazioni",
  //   exact: true,
  //   auth: true,
  //   component: Info,
  //   layout: "/admin"
  // },
  {
    path: "/login",
    name: "Login",
    exact: true,
    auth: false,
    component: Login,
    layout: "/auth",
  },
  {
    path: '',
    exact: false,
    auth: false,
    component: NoMatch,
  },
];

export default routes;
